import React from 'react';
import PropTypes from 'prop-types';

import map from 'lodash/map';
import toUpper from 'lodash/toUpper';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';

import Moment from 'moment';

import IESurveyTable from './IESurveyTable';
import IEErrorMessage from '../IEErrorMessage';

const timeZone = require('moment-timezone');

const IESurveyList = ({ surveyList, studies }) => {
  if (isEmpty(surveyList)) {
    const message = (
      <span>
        There is no survey created to this user please create survey using{' '}
        <strong>{'"'}Create Your Turn-Key Omnibus{'"'}</strong>
      </span>
    );
    return <IEErrorMessage message={message} />;
  }

  const getSurveyRows = () => {
    const surveyRows = [];
    map(surveyList, survey => {
      let status = survey.status;
      const statusUpperCase = toUpper(survey.status);
      if (
        !status ||
        statusUpperCase === 'INCOMPLETE' ||
        statusUpperCase === 'NEW' ||
        statusUpperCase === 'N'
      ) {
        status = 'Incomplete';
      } else if (statusUpperCase === 'SUBMITTED') {
        status = 'Submitted';
      } else if (statusUpperCase === 'LAUNCHED') {
        status = 'In field';
      } else if (
        statusUpperCase === 'PROCESSING_RF' ||
        statusUpperCase === 'PROCESSING' ||
        statusUpperCase === 'COMPLETESREACHED' ||
        statusUpperCase === 'PROCESSING_DF' ||
        statusUpperCase === 'PROCESSING_IF' ||
        statusUpperCase === 'PROCESSING_RP' ||
        statusUpperCase === 'PROCESSING_RC' ||
        statusUpperCase === 'PROCESSING_FC'
      ) {
        status = 'Processing';
      } else if (statusUpperCase === 'REVIEWREQUIRED') {
        status = 'Your Review Required';
      } else if (statusUpperCase === 'RELEASED') {
        status = 'Released';
      }
      let studyName = '';
      if (survey.productNo) {
        const surveyStudy = find(
          studies,
          study => study.pn === survey.productNo
        );
        studyName = surveyStudy ? surveyStudy.sd : '';
      }
      let modifiedOn = timeZone
        .tz(new Date(survey.modifiedDate).getTime(), 'GMT')
        .format('MM/DD/YYYY HH:mm:ss');
      if (!survey.modifiedDate) {
        modifiedOn = timeZone
          .tz(new Date(survey.createdDate).getTime(), 'GMT')
          .format('MM/DD/YYYY HH:mm:ss');
      }
      const row = {
        ...survey,
        status,
        studyName,
        modifiedOn,
        creator: `${survey.firstName || ''} ${survey.lastName || ''}`,
      };
      surveyRows.push(row);
      return null;
    });
    return surveyRows;
  };

  const surveyListRows = getSurveyRows();

  const sortedSurveyList = orderBy(
    surveyListRows,
    o => {
      return new Moment(o.modifiedOn, 'MM/DD/YYYY HH:m:s');
    },
    ['desc']
  );

  return (
    <div className="ie-survey">
      <h1 className="ie-title">Turn-Key Omnibus</h1>
      {surveyListRows.length > 0 && (
        <IESurveyTable surveyList={sortedSurveyList} />
      )}
    </div>
  );
};

IESurveyList.propTypes = {
  surveyList: PropTypes.instanceOf(Array),
  studies: PropTypes.instanceOf(Array),
};

IESurveyList.defaultProps = {
  surveyList: [],
  studies: [],
};

export default IESurveyList;
